import { render } from "./OutlineButton.vue?vue&type=template&id=ecbb7dd4&scoped=true"
import script from "./OutlineButton.vue?vue&type=script&lang=js"
export * from "./OutlineButton.vue?vue&type=script&lang=js"

import "./OutlineButton.vue?vue&type=style&index=0&id=ecbb7dd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecbb7dd4"]])

export default __exports__